export const SET_USER_DATA = "SET_USER_DATA";

export default {
  [SET_USER_DATA]: (state, userData) => {
    state.currentUser = userData;
  },
};
